<template>
    <div class="page-mentions-legales">
        <!-- <Header /> -->
        <main class="page-mentions-legales__main">
            <section class="section__intro">
                <div class="section__intro-logo">
                    <img src="~/assets/svg/logo-baghera.svg" alt="Baghera Advisory Logo" />
                </div>
                <div class="section__intro-resume">
                    <h1 class="section-title">
                        <span class="section-subtitle">Baghera Advisory</span>
                        <br />Mentions légales
                    </h1>
                    <p class="section-content">
                        Baghera Advisory SAS
                        <br />RCS Bordeaux 883 333 809
                        <br />Siège social : 88 Avenue Jean Cordier - 33600 PESSAC
                    </p>
                </div>
            </section>

            <section class="section__legal section__legal--secondary">
                <h2 class="section__legal-title">Coordonnées de l'éditeur</h2>
                <p class="section__legal-content">
                    Tél. (+33) 06 77 95 69 04
                    <br />Mail : g.sachnine@baghera-advisory.fr
                </p>
            </section>

            <section class="section__legal section__legal--tertiary">
                <h2 class="section__legal-title">Directeur de la publication</h2>
                <p class="section__legal-content">
                    M. Grégory Sachnine
                    <br />Tél. (+33) 06 77 95 69 04
                    <br />Mail : g.sachnine@baghera-advisory.fr
                </p>
            </section>

            <section class="section__legal section__legal--secondary">
                <h2 class="section__legal-title">Hébergement</h2>
                <p class="section__legal-content">
                    Site hébergé par OVH SAS
                    <br />2 rue Kellermann, 59100 Roubaix, France
                    <br />www.ovh.com
                </p>
            </section>

            <section class="section__legal section__legal--tertiary">
                <h2 class="section__legal-title">Propriété intellectuelle</h2>
                <p class="section__legal-content">
                    Toute représentation totale ou partielle de ce site par quelque procédé que ce soit,
                    sans l'autorisation expresse du Directeur de la publication est interdite et
                    constituerait une contrefaçon sanctionnée par les articles L 335-2 et suivants
                    du Code de la propriété intellectuelle.
                </p>
                <p class="section__legal-content">
                    Par dérogation, il est permis à l'utilisateur de télécharger tout document mis à
                    disposition par Baghera Advisory, sans modification du fichier téléchargé.
                </p>
                <p class="section__legal-content">
                    Les marques de Baghera Advisory, ainsi que les logos figurant sur le site sont des
                    éléments protégés par les dispositions du droit de la propriété intellectuelle et
                    ne peuvent faire l'objet, sans consentement du Directeur de la publication, d'aucune
                    reproduction ni représentation partielle ou totale.
                </p>
            </section>

            <section class="section__legal section__legal--secondary">
                <h2 class="section__legal-title">Responsabilité</h2>
                <p class="section__legal-content">
                    L'utilisateur du site Internet reconnaît disposer de la compétence et des moyens
                    nécessaires pour accéder et utiliser ce site, Baghera Advisory ne pouvant en aucun
                    cas être tenue responsable des conséquences de l'utilisation du site et de ses contenus.
                    Il reconnaît également avoir pris connaissance de la présente notice légale et
                    s'engage à la respecter.
                </p>
            </section>

            <section class="section__legal section__legal--tertiary">
                <h2 class="section__legal-title">Crédits</h2>
                <p class="section__legal-content">
                    Stratégie & Création : <a href="https://monsieurfrancois.myportfolio.com" target="_blank">monsieurFrancois.com</a>
                    <br />Réalisation & Développement : <a href="https://renaudcollet.com" target="_blank">renaudcollet.com</a>
                    <br />Photos : Stock images
                </p>
            </section>

            <Footer />
        </main>
    </div>
</template>

<script setup lang="ts">
useSeoMeta({
  title: 'Mentions légales - Baghera Advisory',
  description: 'Mentions légales du site Baghera Advisory. Informations sur l\'éditeur, l\'hébergeur et la propriété intellectuelle.',
  ogTitle: 'Mentions légales - Baghera Advisory',
  ogDescription: 'Mentions légales du site Baghera Advisory. Informations légales et réglementaires.',
  ogImage: 'https://baghera-advisory.fr/img/desktop/panther_1440x532.webp',
  ogImageWidth: 1440,
  ogImageHeight: 532,
  ogType: 'website',
  ogLocale: 'fr_FR',
  ogSiteName: 'Baghera Advisory',
  ogUrl: 'https://baghera-advisory.fr/mentions-legales',
  twitterCard: 'summary_large_image',
  twitterTitle: 'Mentions légales - Baghera Advisory',
  twitterDescription: 'Mentions légales du site Baghera Advisory. Informations légales et réglementaires.',
  twitterImage: 'https://baghera-advisory.fr/img/desktop/panther_1440x532.webp',
  robots: 'noindex, follow', // Legal pages typically should not be indexed
})

useStructuredData({
  breadcrumbs: [
    { name: 'Accueil', url: '/' },
    { name: 'Mentions légales', url: '/mentions-legales' },
  ],
})
</script>

<style scoped lang="postcss">
.page-mentions-legales {
    @apply flex flex-col items-center w-full bg-primary
    laptop:max-w-[1440px] laptop:mx-auto;

    &__main {
        @apply relative mt-[100px] z-10;
    }
}

.section {
    &-title {
        @apply text-secondary text-3xl font-light mb-8;
    }

    &-subtitle {
        @apply text-secondary font-light text-xl;
    }

    &-content {
        @apply text-primary text-lg mb-6;
    }

    &__intro {
        @apply flex flex-col w-full laptop:flex-row;

        &-logo {
            @apply flex justify-center items-center bg-primary w-full p-36
            laptop:p-32 laptop:w-1/2;

            img {
                @apply w-[38.125vw] max-w-[223px];
            }
        }

        &-resume {
            @apply flex justify-center items-start flex-col bg-tertiary py-20 px-8
            laptop:px-28;
        }
    }

    &__legal {
        @apply flex flex-col items-start py-20 px-8 w-full
        laptop:px-28;

        &--secondary {
            @apply bg-secondary;

            .section__legal-title {
                @apply text-tertiary;
            }

            .section__legal-content {
                @apply text-primary;
            }
        }

        &--tertiary {
            @apply bg-tertiary;

            .section__legal-title {
                @apply text-secondary;
            }

            .section__legal-content {
                @apply text-primary;
            }
        }

        &-title {
            @apply text-3xl font-light mb-6;
        }

        &-content {
            @apply text-lg;
        }
    }
}

.nav-link {
    @apply inline-flex items-center justify-center gap-2 px-6 py-3
    bg-primary text-tertiary rounded-4xl
    transition-colors duration-300
    hover:bg-secondary hover:text-white
    focus:outline-none focus:ring-2 focus:ring-secondary focus:ring-offset-2;
}
</style>
